import React, { useState } from 'react';
import { verifyToken } from '../api';

export default function AuthModal({ onAuth }) {
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const valid = await verifyToken(token.trim());
      if (valid) {
        onAuth(token.trim());
      } else {
        setError('Invalid family secret');
      }
    } catch {
      setError('Connection error');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="bg-gray-800 rounded-2xl p-8 w-full max-w-md shadow-xl border border-gray-700">
        <h1 className="text-2xl font-bold text-white mb-2">H-E-B Family Groceries</h1>
        <p className="text-gray-400 mb-6">Enter the family secret to continue</p>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            placeholder="Family secret"
            className="w-full bg-gray-700 border border-gray-600 rounded-xl px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-red-500 text-lg"
            autoFocus
          />
          {error && <p className="text-red-400 mt-2 text-sm">{error}</p>}
          <button
            type="submit"
            disabled={loading || !token.trim()}
            className="mt-4 w-full bg-red-600 hover:bg-red-700 disabled:bg-gray-600 text-white font-semibold py-3 rounded-xl text-lg"
          >
            {loading ? 'Verifying...' : 'Enter'}
          </button>
        </form>
      </div>
    </div>
  );
}
